// PeriodEducationalContent.js
import React from "react";
function PeriodEducationalContent() {
  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <strong>Memahami Siklus Menstruasi - Panduan Lengkap</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Siklus menstruasi</strong> adalah proses alami yang terjadi dalam tubuh wanita setiap bulan,
                dimulai dari hari pertama haid dan berlanjut hingga hari pertama haid berikutnya. Proses ini
                merupakan bagian dari sistem reproduksi wanita dan terjadi sebagai persiapan untuk kemungkinan kehamilan.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Tahapan Siklus Menstruasi:
              </h3>
              <div
                className="alert alert-info"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>1. Fase Menstruasi (Hari 1-7):</strong>
                <br />
                Lapisan rahim luruh dalam bentuk darah dan jaringan dari vagina. Ini adalah periode yang kita sebut "haid"
                atau "menstruasi" dan biasanya berlangsung 3 hingga 7 hari.
                <br/>                <strong>2. Fase Folikuler (Hari 1-13):</strong>
                <br />
                Dimulai dengan hari pertama haid dan berlanjut hingga ovulasi. Selama periode ini, sel telur tumbuh
                di ovarium dalam kantung kecil yang disebut folikel, dan lapisan rahim mulai tumbuh kembali.
                <br/>                <strong>3. Fase Ovulasi (Sekitar Hari ke-14):</strong>
                <br />
                Sel telur matang dilepaskan dari ovarium. Ini adalah periode paling subur dalam siklus, terjadi
                biasanya di tengah siklus (hari ke-14 dalam siklus 28 hari).
                <br/>                <strong>4. Fase Luteal (Hari 15-28):</strong>
                <br />
                Setelah sel telur keluar, folikel berubah menjadi korpus luteum yang menghasilkan hormon progesteron. Jika
                tidak terjadi kehamilan, kadar hormon menurun dan siklus baru dimulai.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Cara Menghitung Siklus Menstruasi:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Tentukan hari pertama:</strong> Hari pertama haid (ketika pendarahan sebenarnya dimulai)
                  adalah hari pertama siklus Anda
                </li>
                <li>
                  <strong>Hitung hari:</strong> Hitung jumlah hari dari hari pertama haid hingga
                  hari sebelum haid berikutnya
                </li>
                <li>
                  <strong>Panjang siklus:</strong> Angka ini adalah panjang siklus Anda (biasanya 21-35 hari)
                </li>
                <li>
                  <strong>Lacak selama beberapa bulan:</strong> Catat panjang siklus Anda selama 3-6 bulan untuk mengetahui
                  rata-rata panjang siklus Anda
                </li>
              </ol>
              <div
                className="alert alert-success mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>Contoh Praktis:</strong>
                <br />
                Jika haid Anda dimulai pada 1 Januari dan haid berikutnya datang pada 29 Januari, maka panjang siklus Anda
                28 hari.
                <br/>                <strong>Menghitung haid berikutnya:</strong> Tambahkan 28 hari ke 1 Januari, maka
                haid berikutnya diperkirakan pada 29 Januari.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Pentingnya Melacak Siklus Menstruasi:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Mengetahui apakah siklus Anda teratur atau tidak</li>
                <li>Merencanakan kehamilan dengan menentukan hari subur</li>
                <li>Menghindari kehamilan dengan mengetahui hari paling subur</li>
                <li>Mendeteksi perubahan tidak normal sejak dini</li>
                <li>Persiapan psikologis dan fisik menjelang datangnya haid</li>
                <li>Menentukan waktu kunjungan dokter dengan lebih baik</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Hari Ovulasi dan Kesuburan</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Ovulasi</strong> adalah pelepasan sel telur matang dari ovarium, ini adalah periode terpenting jika
                Anda mencoba hamil atau menghindarinya.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Kapan Ovulasi Terjadi?
              </h3>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>Aturan Dasar:</strong>
                <br />
                Ovulasi biasanya terjadi <strong>14 hari</strong> sebelum tanggal haid berikutnya.
                <br/>                <strong>Contoh:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Siklus 28 hari: ovulasi pada hari ke-14</li>
                  <li>Siklus 30 hari: ovulasi pada hari ke-16</li>
                  <li>Siklus 32 hari: ovulasi pada hari ke-18</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Masa Subur (Fertile Window):
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                Masa subur adalah hari-hari di mana kehamilan dapat terjadi, meliputi:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>5 hari sebelum ovulasi:</strong> Sperma dapat hidup hingga 5 hari di dalam tubuh
                </li>
                <li>
                  <strong>Hari ovulasi:</strong> Hari paling subur
                </li>
                <li>
                  <strong>1 hari setelah ovulasi:</strong> Sel telur hanya hidup 12-24 jam
                </li>
              </ul>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>Secara keseluruhan:</strong> Masa subur berlangsung sekitar <strong>6 hari</strong> dalam
                setiap siklus.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Tanda-tanda Ovulasi:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Perubahan cairan vagina:</strong> Menjadi jernih dan elastis seperti putih telur
                </li>
                <li>
                  <strong>Peningkatan suhu tubuh ringan:</strong> Setelah ovulasi, suhu tubuh meningkat sedikit
                </li>
                <li>
                  <strong>Nyeri ringan di sisi perut:</strong> Beberapa wanita merasakan nyeri ringan di satu sisi
                </li>
                <li>
                  <strong>Peningkatan gairah seksual:</strong> Hormon ovulasi dapat meningkatkan gairah
                </li>
                <li>
                  <strong>Nyeri ringan pada payudara:</strong> Akibat perubahan hormonal
                </li>
              </ol>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Cara Menentukan Ovulasi dengan Akurat:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Tes ovulasi rumahan:</strong> Mendeteksi peningkatan hormon LH 24-36 jam sebelum ovulasi
                </li>
                <li>
                  <strong>Mengukur suhu basal tubuh:</strong> Setiap pagi sebelum bangun tidur
                </li>
                <li>
                  <strong>Memantau cairan:</strong> Mengamati perubahan harian
                </li>
                <li>
                  <strong>Ultrasonografi (USG):</strong> Di dokter untuk memantau pertumbuhan sel telur
                </li>
              </ul>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 Tips:</strong> Jika Anda mencoba hamil, gunakan{" "}
                <strong>Kalkulator Siklus Menstruasi</strong> di atas untuk menentukan hari subur, lalu gunakan
                tes ovulasi rumahan untuk memastikan waktu ovulasi yang tepat.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Siklus Teratur vs Tidak Teratur</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Mengetahui apakah siklus Anda teratur atau tidak sangat penting untuk kesehatan reproduksi Anda.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Siklus Menstruasi Teratur:
              </h3>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>Karakteristik:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Datang setiap 21-35 hari</li>
                  <li>Selisih antara siklus terpendek dan terpanjang tidak melebihi 7-9 hari</li>
                  <li>Perkiraan tanggalnya dapat diprediksi</li>
                  <li>Durasi haid berkisar antara 3-7 hari</li>
                </ul>
                <br />
                <strong>Contoh:</strong> Jika siklus Anda 26, 28, 27, 29 hari - ini adalah siklus teratur
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Siklus Menstruasi Tidak Teratur:
              </h3>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>Tanda-tanda:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Datang dengan jarak sangat jauh (lebih dari 35 hari) atau sangat dekat (kurang dari 21 hari)</li>
                  <li>Perbedaan besar antara panjang siklus (lebih dari 9 hari)</li>
                  <li>Kesulitan memprediksi tanggal haid</li>
                  <li>Perubahan signifikan dalam jumlah atau durasi pendarahan</li>
                </ul>
                <br />
                <strong>Contoh:</strong> Siklus dengan panjang 22, 35, 28, 40 hari - ini adalah siklus tidak teratur
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Penyebab Siklus Tidak Teratur:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Stres dan tekanan psikologis:</strong> Mempengaruhi hormon
                </li>
                <li>
                  <strong>Perubahan berat badan:</strong> Penurunan atau kenaikan berat badan mendadak
                </li>
                <li>
                  <strong>Sindrom ovarium polikistik (PCOS):</strong> Gangguan hormonal umum
                </li>
                <li>
                  <strong>Masalah tiroid:</strong> Hipotiroid atau hipertiroid
                </li>
                <li>
                  <strong>Olahraga berlebihan:</strong> Terutama dengan kekurangan berat badan
                </li>
                <li>
                  <strong>Menyusui:</strong> Mempengaruhi siklus secara alami
                </li>
                <li>
                  <strong>Mendekati menopause:</strong> Pada usia 40-an siklus menjadi tidak teratur
                </li>
                <li>
                  <strong>Beberapa obat-obatan:</strong> Seperti antidepresan atau pengencer darah
                </li>
              </ol>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Kapan Harus ke Dokter?
              </h3>
              <div
                className="alert alert-danger"
                style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
              >
                <strong>⚠️ Konsultasikan dengan dokter jika:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Haid tiba-tiba berhenti lebih dari 3 bulan (dan Anda tidak hamil)</li>
                  <li>Siklus menjadi tidak teratur setelah sebelumnya teratur</li>
                  <li>Haid terjadi lebih dari sekali setiap 21 hari atau kurang dari sekali setiap 35 hari</li>
                  <li>Pendarahan sangat berat (mengganti pembalut setiap jam)</li>
                  <li>Pendarahan berlangsung lebih dari 7 hari</li>
                  <li>Nyeri hebat yang tidak biasa</li>
                  <li>Pendarahan di antara siklus</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 Catatan:</strong> Wajar jika siklus tidak teratur dalam beberapa tahun pertama setelah pubertas,
                serta pada tahun-tahun mendekati menopause.
              </div>
            </div>
          </div>
        </div>
        <br />
        <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
          Pertanyaan Umum tentang Siklus Menstruasi
        </h2>
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana cara menghitung tanggal menstruasi berikutnya?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Untuk menghitung tanggal <strong>menstruasi berikutnya</strong>, ikuti langkah-langkah sederhana berikut:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Pertama: Perhitungan Manual</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>Catat tanggal hari pertama haid terakhir</li>
                <li>Tambahkan jumlah hari siklus Anda (misalnya 28 hari)</li>
                <li>Hasilnya adalah perkiraan tanggal haid berikutnya</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>Contoh:</strong>
                <br />
                Haid terakhir: 1 Januari
                <br />
                Panjang siklus: 28 hari
                <br />
                Haid berikutnya: 1 Januari + 28 hari = <strong>29 Januari</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Kedua: Kalkulator Siklus Elektronik</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Gunakan <strong>Kalkulator Siklus Menstruasi</strong> di bagian atas halaman untuk mendapatkan:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Tanggal 12 siklus ke depan</li>
                <li>Hari ovulasi untuk setiap siklus</li>
                <li>Masa subur</li>
                <li>Kalender lengkap dan teratur</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Tips untuk Perhitungan Akurat:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Lacak siklus Anda selama 3-6 bulan untuk mengetahui rata-rata panjangnya</li>
                <li>Gunakan aplikasi pelacak siklus untuk memudahkan pencatatan</li>
                <li>Ingat bahwa ini adalah perkiraan - mungkin mundur atau maju beberapa hari</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Berapa panjang siklus menstruasi normal?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Panjang siklus menstruasi normal</strong> bervariasi dari satu wanita ke wanita lain, tetapi
                ada rentang normal yang ditentukan secara medis:
              </p>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>Rentang Normal:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>
                    <strong>Panjang siklus:</strong> 21-35 hari (dari hari pertama haid hingga
                    hari pertama haid berikutnya)
                  </li>
                  <li>
                    <strong>Rata-rata umum:</strong> 28 hari
                  </li>
                  <li>
                    <strong>Durasi haid:</strong> 3-7 hari
                  </li>
                  <li>
                    <strong>Jumlah darah:</strong> 30-40 ml (sekitar dua sendok makan)
                  </li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Contoh Siklus Normal:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Siklus 24 hari - normal (relatif pendek)</li>
                <li>Siklus 28 hari - normal (paling umum)</li>
                <li>Siklus 32 hari - normal (relatif panjang)</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Kapan Siklus Dianggap Tidak Normal?</strong>
              </h4>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <ul style={{ marginTop: "10px" }}>
                  <li>Kurang dari 21 hari</li>
                  <li>Lebih dari 35 hari</li>
                  <li>Haid berlangsung kurang dari 2 hari atau lebih dari 7 hari</li>
                  <li>Pendarahan sangat berat (mengganti pembalut setiap jam)</li>
                  <li>Pendarahan sangat ringan (hanya beberapa tetes)</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 Catatan Penting:</strong> Siklus Anda tidak harus tepat 28 hari untuk dianggap normal.
                Yang penting adalah keteraturan dan konsistensi relatif, bukan angka spesifik.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Kapan Ovulasi Terjadi?</h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Ovulasi</strong> biasanya terjadi di tengah siklus menstruasi, tetapi
                waktu pastinya tergantung pada panjang siklus Anda.
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Aturan Emas:</strong>
              </h4>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                Ovulasi terjadi <strong>14 hari</strong> sebelum tanggal haid berikutnya (bukan 14 hari setelah haid terakhir).
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Contoh berdasarkan panjang siklus:</strong>
              </h4>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr style={{ backgroundColor: "#e7f3fe" }}>
                    <th style={{ textAlign: "center", padding: "12px" }}>
                      Panjang Siklus
                    </th>
                    <th style={{ textAlign: "center", padding: "12px" }}>
                      Hari Ovulasi
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      24 hari
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      Hari ke-10
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      28 hari
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      Hari ke-14
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      30 hari
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      Hari ke-16
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      32 hari
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      Hari ke-18
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Masa Subur (Fertile Window):</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Masa subur lebih luas dari hari ovulasi itu sendiri:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>5 hari sebelum ovulasi:</strong> Sperma dapat hidup hingga 5 hari
                </li>
                <li>
                  <strong>Hari ovulasi:</strong> Peluang kehamilan tertinggi
                </li>
                <li>
                  <strong>1 hari setelah ovulasi:</strong> Sel telur hanya hidup 12-24 jam
                </li>
              </ul>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 Tips:</strong> Gunakan <strong>Kalkulator Siklus Menstruasi</strong> di atas
                untuk menentukan hari ovulasi dan masa subur secara akurat untuk 12 bulan ke depan.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Apa penyebab telat haid?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Ada banyak penyebab yang dapat mengakibatkan <strong>telat haid</strong>,
                tidak semuanya perlu dikhawatirkan:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Penyebab Umum:</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Kehamilan:</strong> Penyebab paling umum terhentinya haid
                </li>
                <li>
                  <strong>Stres dan tekanan psikologis:</strong> Mempengaruhi hormon pengatur siklus
                </li>
                <li>
                  <strong>Perubahan berat badan:</strong> Penurunan atau kenaikan berat badan mendadak
                </li>
                <li>
                  <strong>Olahraga berlebihan:</strong> Terutama bagi atlet profesional
                </li>
                <li>
                  <strong>Sindrom ovarium polikistik (PCOS):</strong> Gangguan hormonal yang mempengaruhi ovulasi
                </li>
                <li>
                  <strong>Masalah tiroid:</strong> Hipotiroid atau hipertiroid
                </li>
                <li>
                  <strong>Menyusui:</strong> Menunda kembalinya haid secara alami
                </li>
                <li>
                  <strong>Obat-obatan:</strong> Beberapa obat seperti antidepresan atau pil KB
                </li>
              </ol>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Kapan Harus ke Dokter?</strong>
              </h4>
              <div
                className="alert alert-danger"
                style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
              >
                <strong>⚠️ Konsultasikan dengan dokter jika:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Haid terlambat lebih dari 3 bulan (dan tidak hamil atau menyusui)</li>
                  <li>Siklus tiba-tiba menjadi tidak teratur setelah sebelumnya teratur</li>
                  <li>Muncul gejala lain seperti nyeri hebat, keputihan tidak normal, atau pertumbuhan rambut berlebihan</li>
                  <li>Usia Anda kurang dari 15 tahun dan haid belum dimulai</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 Catatan:</strong> Telat haid beberapa hari adalah hal normal dan tidak perlu dikhawatirkan.
                Sebagian besar wanita mengalami keterlambatan sesekali dalam siklus mereka.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana cara meredakan nyeri haid?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Nyeri haid</strong> (dismenore) sangat umum, tetapi ada cara
                efektif untuk meredakannya:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Pengobatan Rumahan:</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Hangat:</strong> Gunakan botol air panas atau kompres hangat di perut dan punggung
                </li>
                <li>
                  <strong>Mandi air hangat:</strong> Membantu mengendurkan otot
                </li>
                <li>
                  <strong>Pijat:</strong> Pijat perut dan punggung bawah dengan gerakan melingkar lembut
                </li>
                <li>
                  <strong>Olahraga ringan:</strong> Berjalan, yoga, atau berenang
                </li>
                <li>
                  <strong>Relaksasi:</strong> Latihan pernapasan dalam dan meditasi
                </li>
              </ol>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Obat-obatan:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Pereda nyeri:</strong> Ibuprofen atau parasetamol (diminum saat nyeri mulai)
                </li>
                <li>
                  <strong>Antispasmodik:</strong> Membantu mengendurkan otot rahim
                </li>
                <li>
                  <strong>Pil KB:</strong> Dapat mengurangi intensitas nyeri (konsultasikan dengan dokter)
                </li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Tips Diet:</strong>
              </h4>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>Konsumsi:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Makanan kaya zat besi (daging merah, bayam)</li>
                  <li>Omega 3 (ikan salmon, kacang-kacangan)</li>
                  <li>Buah dan sayuran</li>
                  <li>Banyak air putih</li>
                </ul>
                <br />
                <strong>Hindari:</strong>
                <ul>
                  <li>Kafein berlebihan</li>
                  <li>Garam berlebihan (memperparah kembung)</li>
                  <li>Gula olahan</li>
                  <li>Alkohol</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Kapan Harus ke Dokter?</strong>
              </h4>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>⚠️ Konsultasikan dengan dokter jika:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Nyeri sangat hebat hingga mengganggu aktivitas sehari-hari</li>
                  <li>Pereda nyeri biasa tidak meredakan nyeri</li>
                  <li>Nyeri semakin memburuk seiring waktu</li>
                  <li>Muncul gejala baru seperti pendarahan hebat atau demam</li>
                  <li>Usia Anda di atas 25 tahun dan nyeri muncul tiba-tiba</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PeriodEducationalContent;